import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { cityPattern } from 'constants/patterns';
import { ForeignBusinessConferencesItemModel } from '../types';

const foreignBusinessConferencesItemValidator: ValidateJSModel<ForeignBusinessConferencesItemModel> = {
  Description: { hasValue: true },

  Sponsor: { hasValue: true },

  City: {
    hasValue: {
      validator: {
        format: { pattern: cityPattern, message: 'error.city.pattern' },
      }
    },
  },

  Country: (value, attributes) => {
    if (attributes?.CountryFocused) {
      return {};
    }

    return { hasValue: true, country: { excludeUnitedStates: true } };
  },

  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  Purpose: { hasValue: true },

  Contacts: {
    presence: true,
    model: {
      validator: {
        List: {
          presence: true,
          branchCollection: {
            validator: {
              Explanation: { hasValue: true },
            },
          },
        },
      },
    },
  },
};

export default foreignBusinessConferencesItemValidator;
